import { render, staticRenderFns } from "./DailyMenuSection.vue?vue&type=template&id=30b4cca1"
import script from "./DailyMenuSection.vue?vue&type=script&lang=js"
export * from "./DailyMenuSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports